import React  from 'react';
import './Styles/Loading.css';

function LoadingContent (){
       return(
        <div className="loader">loading...</div>
       ); 
   
}
export default LoadingContent;